import React, { useEffect, useMemo, useState } from 'react';
import useApiControl from '../../../common/useApiControl';
import UserCard from '../UserCard';

function FollowRivalList({ user, listType = 'all' }) {
  const [followUsers, setFollowUsers] = useState([]);
  const [rivalUsers, setRivalUsers] = useState([]);

  const followIds = useMemo(() => {
    try {
      if (Array.isArray(user?.follow)) {
        return user.follow;
      }
      return JSON.parse(user?.follow || '[]');
    } catch {
      return [];
    }
  }, [user?.follow]);

  const rivalIds = useMemo(() => {
    try {
      if (Array.isArray(user?.rivals)) {
        return user.rivals;
      }
      return JSON.parse(user?.rivals || '[]');
    } catch {
      return [];
    }
  }, [user?.rivals]);

  const shouldShowFollow = listType === 'all' || listType === 'follow';
  const shouldShowRival = listType === 'all' || listType === 'rival';

  const { data: followData, executeRequest: fetchFollows } = useApiControl({
    action: '/get_user',
    method: 'POST',
    params: { user_ids: followIds },
  });

  const { data: rivalData, executeRequest: fetchRivals } = useApiControl({
    action: '/get_user',
    method: 'POST',
    params: { user_ids: rivalIds },
  });

  useEffect(() => {
    if (shouldShowFollow && followIds.length) fetchFollows();
    if (shouldShowRival && rivalIds.length) fetchRivals();

    if (!followIds.length) {
      setFollowUsers([]);
    }

    if (!rivalIds.length) {
      setRivalUsers([]);
    }
  }, [followIds, rivalIds, shouldShowFollow, shouldShowRival]);

  useEffect(() => {
    if (Array.isArray(followData)) setFollowUsers(followData);
  }, [followData]);

  useEffect(() => {
    if (Array.isArray(rivalData)) setRivalUsers(rivalData);
  }, [rivalData]);

  return (
    <div style={{ padding: '16px' }}>
      {shouldShowFollow && (
        <>
          <h3>フォロー中のユーザー</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            {followUsers.length > 0 ? (
              followUsers.map((u) => (
                <UserCard key={u.id} user={u} />
              ))
            ) : (
              <div>フォロー中のユーザーはいません</div>
            )}
          </div>
        </>
      )}

      {shouldShowRival && (
        <>
          <h3 style={{ marginTop: shouldShowFollow ? '32px' : 0 }}>ライバル</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            {rivalUsers.length > 0 ? (
              rivalUsers.map((u) => (
                <UserCard key={u.id} user={u} />
              ))
            ) : (
              <div>ライバルユーザーはいません</div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default FollowRivalList;
